export default __webpack_public_path__ + "static/media/burn_tower_BW.998fb644.png";